module.exports = __webpack_public_path__ + "9516853999e6120385a9830ec3474b86.svg";